// Formateo de fechas/horas en la zona horaria de Argentina (UTC-3).
//
// Los timestamps del backend llegan en UTC SIN sufijo de zona
// (ej. "2026-05-20T01:46:42.396000"), por lo que el navegador los interpretaría
// como hora local y se verían adelantados ~3h. Acá los tratamos explícitamente
// como UTC y los mostramos en America/Argentina/Buenos_Aires.
//
// Las fechas SIN hora (ej. vencimientos "2026-05-20") NO se convierten de zona
// para evitar corrimientos de día.
//
// CASO ESPECIAL (v2.29.3): fechas "naive" que vienen como ISO datetime con
// hora exactamente 00:00:00 ("2026-06-16T00:00:00") provienen de date pickers
// del UI (Mongo las guarda como datetime naive). NO son timestamps reales,
// son fechas de comprobantes. Las tratamos como fecha-sola, sin conversión TZ.

const TZ = 'America/Argentina/Buenos_Aires';

function isDateOnly(value) {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);
}

function isNaiveMidnight(value) {
  // ISO con tiempo == 00:00:00(.000)? y SIN sufijo de zona horaria
  return typeof value === 'string'
    && /^\d{4}-\d{2}-\d{2}T00:00:00(\.0+)?$/.test(value);
}

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  if (typeof value === 'string') {
    if (isDateOnly(value) || isNaiveMidnight(value)) {
      const [y, m, d] = value.split('T')[0].split('-').map(Number);
      return new Date(y, m - 1, d); // medianoche local, sin conversión de zona
    }
    const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value);
    const d = new Date(hasTz ? value : value + 'Z');
    return isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

// Fecha + hora (para timestamps: created_at, *_at, etc.)
export function fmtDateTime(value, opts = {}) {
  const d = toDate(value);
  if (!d) return '—';
  return d.toLocaleString('es-AR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
    timeZone: TZ, ...opts,
  });
}

// Solo fecha. Para timestamps con hora real aplica zona AR; para fecha-sola o
// "naive midnight" NO se aplica TZ (evita corrimientos de día).
export function fmtDate(value, opts = {}) {
  const d = toDate(value);
  if (!d) return '—';
  const isPureDate = isDateOnly(value) || isNaiveMidnight(value);
  return d.toLocaleDateString('es-AR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    ...(isPureDate ? {} : { timeZone: TZ }),
    ...opts,
  });
}

export const ARG_TZ = TZ;

// Fecha de HOY en horario local del navegador, en formato YYYY-MM-DD.
// Evita el bug de usar toISOString() (que devuelve la fecha en UTC y puede
// adelantarse un día respecto de la fecha local del usuario/servidor).
export function todayLocalISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
